import { useEffect, useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';

interface DependentFieldOptions {
  condition?: string;
  fieldId: string;
  watch?: UseFormReturn['watch'];
  setValue?: UseFormReturn['setValue'];
  clearErrors?: UseFormReturn['clearErrors'];
}

export const useDependentField = ({ condition, fieldId, watch, setValue, clearErrors }: DependentFieldOptions) => {
  const [fieldToWatch, requiredValue] = useMemo(() => condition?.split('=') ?? [], [condition]);
  const watchedValue = fieldToWatch && watch ? watch(fieldToWatch) : undefined;
  const isActive = !fieldToWatch || !requiredValue || !watch || watchedValue === requiredValue;

  useEffect(() => {
    if (isActive || !fieldToWatch || !requiredValue) return;
    setValue?.(fieldId, null);
    clearErrors?.(fieldId);
  }, [clearErrors, fieldId, fieldToWatch, isActive, requiredValue, setValue]);

  return isActive;
};
